import React from 'react'
import { TargetIcon } from '../ActionPlan/TrackTileComponents/icons'
import { Button } from '~/components/_atoms'
import { useTranslation } from '~/hooks/useTranslation'
import { useActionPlan } from '../ActionPlan/ActionPlanProvider'
import { RightArrow } from '../icons/YnsIcon'

const GoalHeader = () => {
  const { goal } = useActionPlan()
  const { t } = useTranslation('GoalTile')

  return (
    <div className="h-full items-center rounded-lg bg-[#E0F2F9] p-4 text-sm font-medium leading-5 tracking-wide text-intoo-blue-medium">
      <div className="mb-3 flex flex-col items-start gap-1 uppercase">
        <div className="mb-2 flex items-center gap-2">
          <TargetIcon variant="primary" size={20} />
          <span>{t('your_goal_title')}</span>
        </div>
        <span id="left-nav-goal">{goal}</span>
      </div>
      <Button
        href="/orientation/action_plan"
        variant="outline"
        size="sm"
        className="!h-auto flex-grow !whitespace-normal break-words rounded-[20px] px-4 py-2 text-center [&&]:rounded-[20px] [&_.yns-stack]:min-w-0 [&_.yns-stack]:max-w-full"
      >
        <span className="flex w-full items-center justify-center gap-1">
          {t('view_action_plan')}
          <RightArrow className="h-4 w-4" />
        </span>
      </Button>
    </div>
  )
}

export default GoalHeader
